export const Logo = () => (
  <div className="rounded-lg overflow-hidden w-12 ">
    <svg viewBox="0 0 650 650" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_454_1568)">
        <rect width="650" height="650" fill="black" />
        <path
          d="M425.715 99.0909H507.398V393.679C507.398 425.971 499.765 454.373 484.5 478.885C469.382 503.397 448.098 522.552 420.651 536.349C393.203 550 361.131 556.825 324.436 556.825C287.594 556.825 255.449 550 228.001 536.349C200.554 522.552 179.27 503.397 164.152 478.885C149.034 454.373 141.474 425.971 141.474 393.679V99.0909H223.158V386.854C223.158 405.642 227.268 422.375 235.487 437.053C243.854 451.731 255.596 463.253 270.714 471.619C285.833 479.839 303.74 483.949 324.436 483.949C345.132 483.949 363.039 479.839 378.158 471.619C393.423 463.253 405.165 451.731 413.385 437.053C421.605 422.375 425.715 405.642 425.715 386.854V99.0909Z"
          fill="white"
        />
        <circle cx="324.5" cy="140.5" r="42.5" fill="#FF0000" />
        <circle cx="325.5" cy="380.5" r="42.5" fill="#05EE00" />
        <ellipse
          cx="324.905"
          cy="260.5"
          rx="42.9048"
          ry="42.5"
          fill="#FFD600"
        />
      </g>
      <defs>
        <clipPath id="clip0_454_1568">
          <rect width="650" height="650" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);
